import React from "react";
import PropTypes from "prop-types";
import TopDesktop from "./TopDesktop";

function Top({ app, config }) {
  return <TopDesktop app={app} config={config} />;
}

Top.defaultProps = {
  app: null,
  config: {},
};

Top.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Top;
